import { Head, Link, usePage } from "@inertiajs/react";
import { Plus } from "lucide-react";

import { PublicCatalogBanner } from "@/components/public-catalog-banner";
import { Button } from "@/components/ui/button";
import AppLayout from "@/layouts/app-layout";
import { newOrganizationCategoryPath, organizationCategoriesPath } from "@/routes";
import type {
  BreadcrumbItem,
  Category,
  PagyMetadata,
  RansackFilters,
  SharedData,
} from "@/types";

import { CategoriesDataTable } from "./data-table";

interface CategoriesProps {
  data: {
    categories: Category[];
    pagy: PagyMetadata;
  };
  filters: RansackFilters;
  public_catalog_enabled: boolean;
}

export default function Categories({
  data,
  filters,
  public_catalog_enabled,
}: CategoriesProps) {
  const { categories, pagy } = data;
  const { auth } = usePage<SharedData>().props;
  const organizationSlug = auth.current_organization?.slug ?? "";
  const categoriesHref = organizationCategoriesPath(organizationSlug);
  const breadcrumbs: BreadcrumbItem[] = [
    {
      title: "Categorías",
      href: categoriesHref,
    },
  ];
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Categorías" />
      <div className="flex h-full flex-1 flex-col gap-4 p-4">
        <PublicCatalogBanner
          enabled={public_catalog_enabled}
          organizationSlug={organizationSlug}
        />

        <div className="flex flex-col space-y-2">
          <h2 className="text-2xl font-bold">Categorías</h2>
          <p className="text-muted-foreground">
            Gestiona las categorías y subcategorías para organizar proveedores y
            productos
          </p>
        </div>

        <div className="flex items-center justify-between">
          <div className="text-sm text-muted-foreground">
            Total: {pagy.count} categorías
          </div>
          <div className="flex justify-end gap-x-2">
            <Button asChild>
              <Link href={newOrganizationCategoryPath(organizationSlug)}>
                <Plus className="h-4 w-4 mr-2" />
                Nueva Categoría
              </Link>
            </Button>
          </div>
        </div>

        <CategoriesDataTable
          categories={categories}
          pagy={pagy}
          filters={filters}
          organizationSlug={organizationSlug}
        />
      </div>
    </AppLayout>
  );
}
